import React, { FunctionComponent } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Shutdown } from 'components';

const Overview: FunctionComponent<RouteComponentProps> = ({ match: { path } }) => (
  <Switch>
    <Route path={path} component={Shutdown} />
  </Switch>
);

export default Overview;
